export enum EPostReleaseRisk {
  LOW = 0.04,
  MEDIUM = 0.07,
  HIGH = 0.1,
}
